module.exports = __webpack_public_path__ + "static/img/invest-consume1.d4b3b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume1.jpg
// module id = sFzB
// module chunks = 0